import { api } from "./api";

class IdCardApi {
  lookupIdCard = async (params) => {
    try {
      const response = await api.get("/id-card/lookup", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  };

  downloadPass = async (params) => {
    try {
      const response = await api.get("/id-card/download", { 
        params,
        responseType: 'blob' 
      });
      if (response.status === 200) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const idCardApi = new IdCardApi();
export default idCardApi;

export const {
  lookupIdCard,
  downloadPass
} = idCardApi;
